import { render, staticRenderFns } from "./AddResellerPaymentPage.vue?vue&type=template&id=28d162aa"
import script from "./AddResellerPaymentPage.vue?vue&type=script&lang=js"
export * from "./AddResellerPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports